import { useState, useEffect } from 'react'
import { DialogType } from './dialog'
const useDialog = (props: Omit<DialogType, 'content' | 'onClickConfirm'>) => {
    const { onRef, onAfterClose } = props
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [isActionReady, setIsActionReady] = useState<boolean>(false)

    useEffect(() => {
        onRef({
            openDialog,
            closeDialog,
        })

        if (!props.reachedBottom) {
            setIsActionReady(true)
        } else {
            setIsActionReady(false)
        }
    }, [isOpen])

    // useEffect(() => {
    //     if (!props.reachedBottom) {
    //         setIsActionReady(true)
    //     } else {
    //         setIsActionReady(false)
    //     }
    // }, [isOpen])

    const openDialog = () => {
        setIsOpen(true)
    }
    const closeDialog = () => {
        setIsOpen(false)
        onAfterClose?.()
    }
    const handleClickClose = () => {
        closeDialog()
    }

    const setMainActionReady = () => {
        setIsActionReady(true)
    }

    return {
        isOpen,
        isActionReady,
        onClickClose: handleClickClose,
        setMainActionReady,
    }
}

export default useDialog
